/* tslint:disable */

import React from 'react';

interface ITrainIconProps {
    height: string;
    isWithoutBox: boolean;
}

const trainIcon: React.SFC<ITrainIconProps> = props => {
    const icon = (
        <svg
            className='line-icon'
            version='1.1'
            id='Layer_1'
            x='0px'
            y='0px'
            viewBox='0 0 20 20'
            enableBackground='new 0 0 20 20'
            height={props.height}
        >
            <path
                fill='#FFFFFF'
                d='M15.601 17.52H4.4c-1.06 0-1.92-0.86-1.92-1.92V4.399c0-1.06 0.86-1.92 1.92-1.92h11.201
        c1.06 0 1.92 0.86 1.92 1.92V15.6C17.521 16.66 16.661 17.52 15.601 17.52z'
            />
            <g>
                <path
                    fill='#8C4799'
                    d='M0 2.475C0 1.125 1.125 0 2.475 0h15C18.875 0 20 1.125 20 2.475v15c0 1.4-1.125 2.525-2.525 2.525h-15
            C1.125 20 0 18.875 0 17.475V2.475z M15.35 2.55C14.8 2.05 12.425 1.475 10 1.475c-2.35 0-4.775 0.575-5.3 1.075
            C4.325 2.875 3.95 3.625 3.5 4.575c-0.375 0.825-0.675 1.6-0.675 2.05v7.225c0 0.575 0.2 0.825 0.975 1.425
            c0.575 0.45 0.825 0.65 1.7 0.65h1.65V17h5.775v-1.075h1.625c0.875 0 1.125-0.2 1.675-0.65c0.775-0.625 0.95-0.85 0.95-1.425V6.625
            c0-0.45-0.3-1.225-0.65-2.05C16.075 3.625 15.725 2.875 15.35 2.55z M14.675 17.75V16.7H13.75v1.05H6.3V16.7H5.35v1.05H4.2
            c-0.275 0-0.5 0.225-0.5 0.475c0 0.275 0.225 0.5 0.5 0.5h11.65c0.275 0 0.475-0.225 0.475-0.5c0-0.25-0.2-0.475-0.475-0.475
            H14.675z M14.15 11.375c-0.075 0.425-0.5 0.75-0.925 0.75h-6.4c-0.425 0-0.85-0.325-0.925-0.75L4.725 6.4
            C4.65 5.975 4.925 5.65 5.35 5.65h9.325C15.1 5.65 15.4 5.975 15.3 6.4L14.15 11.375z M13.8 3.425V3.85c0 0.325-0.25 0.6-0.575 0.6
            h-6.4c-0.325 0-0.6-0.275-0.6-0.6V3.425H13.8z M6.225 13.975c0-0.35 0.25-0.625 0.6-0.625c0.35 0 0.65 0.275 0.65 0.625
            s-0.3 0.6-0.65 0.6C6.475 14.575 6.225 14.325 6.225 13.975z M12.6 13.9c0-0.35 0.275-0.625 0.625-0.625
            c0.35 0 0.625 0.275 0.625 0.625s-0.275 0.6-0.625 0.6C12.875 14.5 12.6 14.25 12.6 13.9z'
                />
            </g>
        </svg>
    );

    const iconWithoutBox = (
        <svg
            className='line-icon'
            version='1.1'
            id='Layer_1'
            x='0px'
            y='0px'
            viewBox='0 0 1024 1024'
            enableBackground='new 0 0 16 16'
            height={props.height}
        >
            <g>
                <path
                    fill='#FFFFFF'
                    d='M937.929 305.712v428.902c0 34.135-10.386 47.49-56.395 84.594-32.646 26.711-47.49 38.585-99.431 38.585h-96.465v63.815h-342.823v-63.818h-97.949c-51.944 0-66.784-11.874-100.915-38.585-46.009-35.616-57.88-50.459-57.88-84.594v-428.898c0-26.711 17.81-72.72 40.070-121.694 26.714-56.395 48.978-100.919 71.239-120.21 31.161-29.68 175.12-63.815 314.624-63.815 143.955 0 284.943 34.135 317.59 63.815 22.26 19.291 43.039 63.815 69.754 120.21 20.776 48.975 38.582 94.984 38.582 121.694zM859.273 966.128c16.325 0 28.196 13.355 28.196 28.196 0 16.325-11.871 29.68-28.196 29.68h-691.578c-16.325 0-29.68-13.359-29.68-29.68 0-14.84 13.355-28.196 29.68-28.196h68.265v-62.33h56.398v62.33h442.253v-62.33h54.914v62.33h69.747zM826.627 292.356c5.935-25.23-11.874-44.524-37.104-44.524h-553.565c-25.226 0-41.555 19.294-37.097 44.524l69.75 295.333c4.451 25.23 29.68 44.524 54.91 44.524h379.923c25.23 0 50.463-19.294 54.914-44.524l68.269-295.333zM287.902 115.748v25.23c0 19.294 16.325 35.619 35.616 35.619h379.923c19.294 0 34.138-16.325 34.138-35.619v-25.23h-449.677zM362.106 742.033c0-20.776-17.806-37.104-38.589-37.104-20.776 0-35.616 16.325-35.616 37.104 0 20.776 14.84 35.616 35.616 35.616 20.783 0 38.589-14.84 38.589-35.616zM740.549 737.579c0-20.776-16.321-37.104-37.104-37.104-20.776 0-37.097 16.325-37.097 37.104 0 20.776 16.321 35.616 37.097 35.616 20.783 0.004 37.104-14.84 37.104-35.616z'
                />
            </g>
        </svg>
    );

    return props.isWithoutBox ? iconWithoutBox : icon;
};

export default trainIcon;
